import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { axiosGet, axiosPatch, axiosPost } from "Redux/axiosHelper"
import { Step1BodyTypes, Step4CurriculumPayload, UpdateClassStatusBody, UpdateClassStep4Body, UpdateClassStep5Body, UpdateClassStep7Body, UpdateClassStep8Body, UpdateEduClassStep2Body, UpdateEduClassStep3Body, UpdateStep6LateFeeBody, UpdateStep6TicketStatusBody } from "types/Classes/Classes"
import { AdmissionTicketPayloadTypes } from "types/event/eventStep4"
import { string } from "yup/lib/locale"


//step 1
const createClassesStep1 = async ({
  body
}: {
  body: Step1BodyTypes
}) => {
  const response = await axiosPost(
    body,
    `v1/edu-class/step1-details`,
  )
  return response.data
}

const editClassesStep1 = async ({
  body,
  classId,
}: {
  body: Step1BodyTypes
  classId: string
}) => {
  const response = await axiosPatch(
    body,
    `v1/edu-class/${classId}/step1-details`,
  )
  return response.data
}

export const useCreateClassStep1Mutation = () => {
  return useMutation(createClassesStep1)
}

export const useEditClassStep1Mutation = () => {
  return useMutation(editClassesStep1)
}

//step 2

const editClassesStep2 = async ({
  body,
  classId,
}: {
  body: UpdateEduClassStep2Body
  classId: string
}) => {
  const response = await axiosPatch(
    body,
    `v1/edu-class/${classId}/step2-contacts`,
  )
  return response.data
}

export const useEditClassStep2Mutation = () => {
  return useMutation(editClassesStep2)
}



//step 3

const editClassesStep3 = async ({
  body,
  classId,
}: {
  body: UpdateEduClassStep3Body
  classId: string
}) => {
  const response = await axiosPatch(
    body,
    `v1/edu-class/${classId}/step3-day-hours`,
  )
  return response.data
}

export const useEditClassStep3Mutation = () => {
  return useMutation(editClassesStep3)
}





//step5

const editClassesStep5 = async ({ body, classId }: { body: UpdateClassStep5Body, classId: string }) => {

  const response = await axiosPatch(body, `v1/edu-class/${classId}/step5-cost-and-fee`)
  return response.data
}

export const useEditStep5Mutation = () => {
  return useMutation(editClassesStep5)
}


//step 7 (Communication)

const editClassesStep7 = async ({ body, classId }: { body: UpdateClassStep7Body, classId: string }) => {
  const response = await axiosPatch(body, `v1/edu-class/${classId}/step7-communication`)
  return response.data
}

export const useEditStep7Mutation = () => {
  return useMutation(editClassesStep7)
}

//step 8 (Settings)

const editClassesStep8 = async ({ body, classId }: { body: UpdateClassStep8Body, classId: string }) => {
  const response = await axiosPatch(body, `v1/edu-class/${classId}/step-8/settings`)
  return response.data
}

export const useEditStep8Mutation = () => {
  return useMutation(editClassesStep8)
}


//Update Class Status

const UpdateClassStatus = async ({ body, classId }: { body: UpdateClassStatusBody, classId: string }) => {
  const response = await axiosPatch(body, `v1/edu-class/${classId}/status`)
  return response.data
}

export const useUpdateClassStatusMutation = () => {
  const queryClient = useQueryClient()
  return useMutation(UpdateClassStatus, {
    onSuccess: data => {
      queryClient.setQueryData(
        ['class-details', data._id],
        (oldData: any) => {
          return oldData ? { ...oldData, ...data } : data
        },
      )
      // Invalidate common class listings to refresh the list
      queryClient.invalidateQueries(['common-class-listing'])
    },
  })
}


//Get Class Details

const GetClassDetails = async (classId: string) => {
  const response = await axiosGet(`v1/edu-class/${classId}`)
  return response.data
}

export const useGetClassDetailsQuery = (classId: string) => {
  return useQuery({
    queryKey: ['class-details', classId],
    queryFn: () => GetClassDetails(classId),
    enabled: !!classId,
  })
}
